import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

export default function Unauthorized() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'grey.50',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        py: { xs: 6, sm: 12 },
        px: { xs: 2, sm: 6, lg: 8 },
      }}
    >
      <Container maxWidth="sm">
        <Paper
          sx={{
            py: 8,
            px: { xs: 4, sm: 10 },
            textAlign: 'center',
          }}
          elevation={2}
        >
          <BlockIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2,
            }}
          />
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            You don't have permission to access this page. Please contact your administrator if
            you believe this is an error.
          </Typography>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
            size="large"
          >
            Go to Home
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
